<template>
  <div class="slotRemark">
    <div class="termBtn">
      <el-button type="primary" @click="addList">添加語言</el-button>
    </div>
    <div class="termCon" v-if="update.col.data.length>0">
      <el-form v-for="(item,index) in update.col.data" :inline="true">
        <el-form-item class="langBox" :label="$t('im.common.locale')" v-if="typeof item.language!=='undefined'">
          <el-select v-model="item.language">
            <el-option v-for="lang in langList"
                       :label="lang.name"
                       :value="lang.id"
                       :key="lang.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="inputBox">
          <el-input
                    v-if="typeof item.title!=='undefined'"
                    v-model="item.title"
                    :placeholder="item.title"></el-input>
          <el-input class="inputTextarea" type="textarea"
                    v-if="typeof item.illustrate!=='undefined'"
                    :rows="6"
                    v-model="item.illustrate"
                    :placeholder="item.illustrate"></el-input>
        </el-form-item>
        <el-form-item>
          <i class="el-icon-delete" style="font-size:24px;" @click="delList(index)"></i>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slotRemark',
  props: ['update'],
  data() {
    return {
      langList: [{ id: 'zh_CN', name: '简体中文' },{ id: 'zh_TW', name: '繁體中文' }, { id: 'en_US', name: 'English' }, { id: 'vi_VN', name: 'Tiếng Việt' }, { id: 'hi_IN', name: 'हिंदी' }]
    }
  },
  methods: {
    addList() {
      if (this.update.col.arr) {
        this.update.col.data.push({title: '', language: ''} )
      } else {
        this.update.col.data.push({ title: '', illustrate: '', language: '' })
      }
    },
    delList(index){
      this.update.col.data.splice(index,1)
    }
  }
}
</script>
<style>
.slotRemark {
  overflow: hidden;
}
.slotRemark .termBtn {
  overflow: hidden;
  width: 20%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.slotRemark .termCon {
  width: 90%;
  border: solid 1px #ddd;
  border-radius: 4px;
  padding: 5px 0;
  margin: 0 0 20px;
  float: right;
}
.slotRemark .termCon .el-form {
  border-bottom: solid 1px #ddd;
  padding: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.slotRemark .termCon .el-form:last-child {
  border-bottom: none;
}
.slotRemark .termCon .langBox .el-form-item__content{
  width: 60%;
}
.slotRemark .termCon .inputBox {
  justify-content: flex-start;
  width: 70%;
}
.slotRemark .termCon .el-form-item{
  margin-bottom: 0;
}
.slotRemark .termCon .inputBox .el-form-item__content {
  width: 100%;
}
.slotRemark .termCon .inputBox .inputTextarea {
  margin-top: 20px;
}
</style>
